import React from 'react';
import Skeleton from '~components/skeleton';
import './style.scss';
import '../style.scss';

function ActivityLoader({ isMobile }) {
    return (
        <div className="activity">
            <div className="activity__head">
                <h3>
                    <Skeleton
                        width={isMobile ? 212.5 : 280}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 24 : 38}
                    />
                </h3>
            </div>
            <div className="activity__wrap">
                <div className="activity__item">
                    <div className="activity__inner">
                        <span className="activity__inner-value">
                            <Skeleton width={13.95} fontSize={isMobile ? 23 : 24} lineHeight={32} />
                        </span>
                        <span className="activity__inner-icon">
                            <Skeleton width={24} lineHeight={24} />
                        </span>
                    </div>
                    <span className="activity__text">
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        {isMobile && <Skeleton width={150} fontSize={13} lineHeight={15} />}
                    </span>
                </div>
                <div className="activity__item">
                    <div className="activity__inner">
                        <span className="activity__inner-value">
                            <Skeleton width={13.95} fontSize={isMobile ? 23 : 24} lineHeight={32} />
                        </span>
                        <span className="activity__inner-icon mt1">
                            <Skeleton width={24} lineHeight={24} />
                        </span>
                    </div>
                    <span className="activity__text">
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        {isMobile && <Skeleton width={150} fontSize={13} lineHeight={15} />}
                    </span>
                </div>
                <div className="activity__item">
                    <div className="activity__inner">
                        <span className="activity__inner-value">
                            <Skeleton width={13.95} fontSize={isMobile ? 23 : 24} lineHeight={32} />
                        </span>
                        <span className="activity__inner-icon mt1">
                            <Skeleton width={24} lineHeight={24} />
                        </span>
                    </div>
                    <span className="activity__text">
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        <Skeleton
                            width={isMobile ? 150 : 190}
                            fontSize={isMobile ? 13 : 15}
                            lineHeight={isMobile ? 15 : 20}
                        />
                        {isMobile && <Skeleton width={150} fontSize={13} lineHeight={15} />}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ActivityLoader;
export { ActivityLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/activity/loader/index.js